import React from 'react'
// import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {BaseStatusTag, CheckmarkIcon, SkeletonButton} from '@modifi/ui'
import {landGreen} from '@modifi/colors'

const propTypes = {}
const defaultProps = {}

type PlaceholderProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const Placeholder: React.FC<PlaceholderProps> = props => (
  <SkeletonButton>
    <BaseStatusTag
      backgroundColor={landGreen}
      dataIdent="shipment-status-tag"
      data-status="placeholder"
      iconComponent={CheckmarkIcon}
      {...props}
    >
      Unknown
    </BaseStatusTag>
  </SkeletonButton>
)

Placeholder.propTypes = propTypes
Placeholder.defaultProps = defaultProps

export default Placeholder
